const questionnaireAPI = process.env.REACT_APP_QUESTIONNAIRE_API
const uploadFileAPI = process.env.REACT_APP_API_SELF_UPLOAD
const selfQuestionnaireAPI = process.env.PUBLIC_URL
const uploadFilesAPI = process.env.REACT_APP_UPLOAD_FILES_API
const cmsAPI = process.env.REACT_APP_CMS_API
const webBaseAPI = process.env.REACT_APP_WEBBASE_API_URL

export default {
    // otp
    getOTP: questionnaireAPI + '/otp/get',
    confirmOTP: questionnaireAPI + '/otp/confirm',
    getForgotPasswordOTP: questionnaireAPI + '/otp/get-forgot-password',
    // user
    addUser: questionnaireAPI + '/user/add',
    getUser: questionnaireAPI + '/user/me',
    getUserByID: questionnaireAPI + '/user/{{userID}}',
    searchUser: questionnaireAPI + '/user/search',
    // updateUser: questionnaireAPI + '/user/{{uid}}',
    updatePassword: questionnaireAPI + '/user/password',
    getOverviewDashboardByUser: questionnaireAPI + '/sum/community/{{questID}}',
    getFullOverviewDashboardByUser: questionnaireAPI + '/sum/full/community/{{questID}}}',
    getLookupQuestionnaireByUser: questionnaireAPI + '/sum/questionnaire',
    getQuestionnaireCompareByUser: questionnaireAPI + '/sum/compare/{{questID}}',
    updateUserNewService: questionnaireAPI + '/user/{{uid}}/update',
    // lookup
    getLookupTitleName: questionnaireAPI + '/lookup/prefix',
    getLookupProvince: questionnaireAPI + '/lookup/province',
    getLookupDistrict: questionnaireAPI + '/lookup/amphoe',
    getLookupSubdistrict: questionnaireAPI + '/lookup/tambon',
    getLookupCommunity: questionnaireAPI + '/lookup/community',
    getLookupProvinceCommunity: questionnaireAPI + '/lookup/provinceInCommunity',
    getLookupDevelopmentDASTA: selfQuestionnaireAPI + '/lookup/lookup.json',
    getLookupColorChart: selfQuestionnaireAPI + '/lookup/lookup.json',
    getLookupCluster: questionnaireAPI + '/lookup/cluster', // เขต
    getLookupClusterProvince: questionnaireAPI + '/lookup/cluster',
    getLookupQuestionnaireStatus: questionnaireAPI + '/lookup/questionnaireStatus',
    getLookupQuestionnaireScore: questionnaireAPI + '/lookup/questionnaire/score',
    getLookupQuestionnaireGrade: questionnaireAPI + '/lookup/questionnaire/grade',
    getCommunityAutoComplete: questionnaireAPI + '/lookup/community-auto-complete',
    getFacility: questionnaireAPI + '/lookup/facility',
    getPayment: questionnaireAPI + '/lookup/payment',
    getMonth: questionnaireAPI + '/lookup/month',
    getDayOfWeek: questionnaireAPI + '/lookup/dayOfWeek',
    getAccommodation: questionnaireAPI + '/lookup/accommodation',
    getTouristTarget: questionnaireAPI + '/lookup/touristTarget',
    getLanguage: questionnaireAPI + '/lookup/language',
    //auth
    getNewToken: questionnaireAPI + '/auth/gen-new-token',
    getNewTokenAdmin: questionnaireAPI + '/auth/gen-new-token-admin', //
    getNewTokenSelf: questionnaireAPI + '/auth/gen-new-token-self',
    signIn: questionnaireAPI + '/auth/sign-in',
    // community
    getSearchCommunity: questionnaireAPI + '/community/search',
    getOneCommunity: questionnaireAPI + '/community/detail/{{commID}}',
    getCommunityImage: questionnaireAPI + '/community/image/{{commID}}',
    //manage-files
    uploadFiles: uploadFilesAPI + '/to-temp',
    //questionnaire
    addQuestionnaire: questionnaireAPI + '/questionnaire/add',
    editQuestionnaire: questionnaireAPI + '/questionnaire/{{id}}',
    getQuestionnaireDraftByAdmin: questionnaireAPI + '/questionnaire/admindraft/{{commID}}',
    getQuestionnaireByMe: questionnaireAPI + '/questionnaire/me',
    getQuestionnaireByAdmin: questionnaireAPI + '/questionnaire/me/{{commID}}',
    deleteDraftQuestionnaire: questionnaireAPI + '/questionnaire/draft/{{questID}}',
    deleteDraftQuestionnaireAdmin: questionnaireAPI + '/questionnaire/draft/{{questID}}/{{commID}}',
    takeDraftQuestionnaireSubmittedAdmin: questionnaireAPI + '/questionnaire/finishdraft/{{questID}}/{{commID}}',
    takeDraftQuestionnaireSubmitted: questionnaireAPI + '/questionnaire/finishdraft/{{questID}}',
    takeDraftQuestionnaire: questionnaireAPI + '/questionnaire/savedraft/{{questID}}/user',
    takeDraftQuestionnaireAdmin: questionnaireAPI + '/questionnaire/savedraft/{{questID}}/{{commID}}/admin',
    takeUpdateDraftQuestionnaireAdmin: questionnaireAPI + '/questionnaire/updatedraft/{{questID}}/{{commID}}/admin',
    takeUpdateDraftQuestionnaire: questionnaireAPI + '/questionnaire/updatedraft/{{questID}}/user',
    takeQuestionnaire: questionnaireAPI + '/questionnaire/assess/{{questID}}/user',
    takeQuestionnaireByAdmin: questionnaireAPI + '/questionnaire/assess/{{questID}}/{{commID}}/admin',
    displayQuestionnaireToDo: questionnaireAPI + '/questionnaire', // {questID}/{time}
    displayQuestionnaireDraftAdmin: questionnaireAPI + '/questionnaire/draft/{{questID}}/{{commID}}', // {questID}/{time}
    displayQuestionnaireDraft: questionnaireAPI + '/questionnaire/draft/{{questID}}/user', // {questID}/{time}
    getQuestionnaireForm: questionnaireAPI + '/questionnaire/{{questID}}',
    questionnaireSearch: questionnaireAPI + '/questionnaire/search',
    copyQuestionnaire: questionnaireAPI + '/questionnaire/copy/{{questID}}',
    deleteQuestionnaire: questionnaireAPI + '/questionnaire/{{questID}}',
    setNewPublishTime: questionnaireAPI + '/questionnaire/publish/{{questID}}',
    endPublish: questionnaireAPI + '/questionnaire/expire/{{questID}}',
    //admin
    selfEstimateByMe: questionnaireAPI + '/questionnaire/assessed/{{questID}}/{{commID}}',
    postAssessedAllResult: questionnaireAPI + '/questionnaire/assessed/all-result',
    selfEstimate: questionnaireAPI + '/questionnaire/assessed/{{questID}}',
    selfEstimateList: questionnaireAPI + '/questionnaire/manage-assessed/{{questID}}/{{commID}}',
    getLookupQuestionnaireByAdmin: questionnaireAPI + '/sum/questionnaire/{{commID}}',
    getCompare: questionnaireAPI + '/sum/compare',
    getSummaryCompare: questionnaireAPI + '/sum/compare/{{questID}}/{{commID}}',
    getOverviewDashboardByAdmin: questionnaireAPI + '/sum/community/{{questID}}/{{commID}}',
    getUserByIDAdmin: questionnaireAPI + '/user/me-admin',
    getUserQuestionnaireForm: questionnaireAPI + '/questionnaire/userResult/{{questID}}/{{commID}}',
    getDraftBoard: questionnaireAPI + '/questionnaire/draftboard/{{questID}}/{{commID}}',
    getBoard: questionnaireAPI + '/questionnaire/boardnames/{{commuID}}/{{questID}}',
    // portal
    webCmsAuth: cmsAPI + '/auth/verify-system',
    //report
    getReportCommunity: questionnaireAPI + '/report/community',
    getLookupReportCommunity: questionnaireAPI + '/report/community-lookup',
    getFullPreviewReport: questionnaireAPI + '/report/full/{{commID}}/{{questID}}',
    getFullPreviewReportAdmin: questionnaireAPI + '/report/full/{{commID}}/{{questID}}/admin',

    //editRequest
    postEditRequest: questionnaireAPI + '/questionnaire/edit-request',
    postApproveEditRequest: questionnaireAPI + '/questionnaire/approve-request',
    // signInByWebBase: appAPI + '/auth/webbase/signIn',
    webBaseAuth: webBaseAPI + '/auth/webbase/verify-system',
    signInByWebBase: webBaseAPI + '/auth/webbase/signIn',
    getQuestionnaireResult: questionnaireAPI + '/questionnaire/result',
    getCommittees: questionnaireAPI + '/lookup/boardname',
    getInstitution: questionnaireAPI + '/lookup/institution',
    getInitialLink: questionnaireAPI + '/questionnaire/link',
    postCopyLink: questionnaireAPI + '/questionnaire/copy-link',
    postDraftLink: questionnaireAPI + '/questionnaire/link/draft',
    deleteDraftByLink: questionnaireAPI + '/questionnaire/link/draft/bylink',
    deleteAllDraftLink: questionnaireAPI + '/questionnaire/link/draft/all',
    getInitialFile: uploadFileAPI + '/questionnaire/file',
    deletedraftByFile: uploadFileAPI + '/questionnaire/file/draft/byfile',
    deleteAlldraftFile: uploadFileAPI + '/questionnaire/file/draft/all',
    postDraftFile: uploadFileAPI + '/questionnaire/file/draft',
    postCopyfile: uploadFileAPI + '/questionnaire/copy-file',
    getInitialSelectFile: uploadFileAPI + '/questionnaire/select/file',
    postAddSelectFile: uploadFileAPI + '/questionnaire/select/file/draft',
    postCopyFileAndLink: questionnaireAPI + '/questionnaire/copy-for-edit',
    getManageFile: questionnaireAPI + '/questionnaire/manage-files/{{commID}}/{{questID}}',
    getLookupCommunityCategory: questionnaireAPI + '/lookup/community-category',
    getLookupReward: questionnaireAPI + '/lookup/reward',
    getLookupStandard: questionnaireAPI + '/lookup/standard',
}
